import React, { useEffect, useState } from "react";
import firebase from "../../config/firebase";
import { Route, Switch, withRouter } from "react-router-dom";
import Layout from "../Layout/index";
import MainWrapper from "./MainWrapper";

import LogIn from "../LogIn/index";
import Account from "..//User/Account/index";
// Jobs
import PostJob from "../PostJob/index";
import ViewAllJobs from "../AllJobsPage/index";
import ViewJobPage from "../ViewJobPage/index";
// import PreviewJob from "../PreviewJob/PreviewJob";
// Companies
import ViewAllCompanies from "../AllCompaniesPage/index";
import ViewCompanyPage from "../ViewCompanyPage/index";
import Subscriptions from "../Subcriptions/index";
import Email from "../Email/index";
import Settings from "../Settings/index";
import { signin, signout } from "../../redux/middlewares/authMIddleware";
import { connect } from "react-redux";
import AdminPrivateRoute from "./PrivateRoute/AdminPrivateRoute";
import PrivateRoute from "./PrivateRoute/PrivateRoute";
import store from "./store";
import { signInAction } from "../../redux/actions/authActions";
import { toast } from "react-toastify";
import Resources from "../AllResourcesPage/index";

const Jobs = () => (
  <Switch>
    <Route exact path="/jobs/post-job" component={PostJob} />
    <Route exact path="/jobs/view-jobs" component={ViewAllJobs} />
    <AdminPrivateRoute
      exact
      path="/jobs/view-paid-jobs"
      component={ViewAllJobs}
    />
    {/* <Route exact path="/jobs/preview-job/:id" component={PreviewJob} /> */}
    <Route exact path="/jobs/:id" component={ViewJobPage} />
  </Switch>
);
const Companies = () => (
  <Switch>
    <Route
      exact
      path="/companies/view-companies"
      component={ViewAllCompanies}
    />
    <Route exact path="/companies/:id" component={ViewCompanyPage} />
  </Switch>
);
const User = () => <Route exact path="/user/account" component={Account} />;
// const Resources = () => (
//   <Switch>
//     <Route exact path="/resources" component={AllResourcesPage} />
//   </Switch>
// );

const wrappedRoutes = () => (
  <div>
    <Layout />
    <div className="container__wrap">
      <PrivateRoute path="/jobs" component={Jobs} />
      <PrivateRoute path="/resources" component={Resources} />
      <PrivateRoute path="/companies" component={Companies} />
      <AdminPrivateRoute path="/user" component={User} />
      <AdminPrivateRoute path="/subscriptions" component={Subscriptions} />
      <AdminPrivateRoute path="/email" component={Email} />
      <AdminPrivateRoute path="/settings" component={Settings} />
    </div>
  </div>
);

const Router = props => {
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(true);
  const DB = firebase.firestore();
  let initialLoad = true;
  useEffect(() => {
    // Checking connection
    var connectedRef = firebase.database().ref(".info/connected");
    connectedRef.on("value", function(snap) {
      console.log(snap.val());
      if (snap.val() === true) {
        if (!initialLoad) {
          toast.success("Connected Successfully.");
        }
        initialLoad = false;
      } else {
        if (!initialLoad) toast.error("Not Connected.");
      }
    });

    // Checking Authentication Status
    const token = localStorage.getItem("token");
    if (!token) {
      props.signout();
    }
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        const userRef = DB.collection("users").doc(user.uid);
        userRef
          .get()
          .then(userDoc => {
            setLoading(false);
            setLoaded(true);
            if (userDoc.exists) {
              localStorage.setItem("token", user.refreshToken);
              store.dispatch(signInAction(userDoc.data()));
              if (props.location.pathname === "/log_in") {
                let pathToGo =
                  userDoc.data().dataEntry === true
                    ? "/jobs/post-job"
                    : "/jobs/view-jobs";
                props.history.push(pathToGo);
              } else {
                props.history.push(props.location.pathname);
              }
            } else props.history.push("log_in");
          })
          .catch(err => {
            toast.error(err.message);
          });
        // console.log({ user });
      } else {
        setLoaded(true);
        // console.log({ signout: user });
        props.history.push("/log_in");
      }
    });

    // // Checking
    // let auth = firebase.auth();
    // let emailAddress = "rehan.saeed@denovers.com";

    // auth
    //   .sendPasswordResetEmail(emailAddress)
    //   .then(function() {
    //     alert("email sent");
    //   })
    //   .catch(function(error) {
    //     alert("error: " + error.message);
    //   });
  }, []);

  return (
    <MainWrapper>
      <main>
        {/* <ToastContainer /> */}
        {!loaded ? (
          <div className={`load${loading ? "" : " loaded"}`}>
            <div className="load__icon-wrap">
              <svg className="load__icon">
                <path
                  fill="#4ce1b6"
                  d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"
                />
              </svg>
            </div>
          </div>
        ) : (
          <Switch>
            {/* <Route path="/jobs/:id" component={ViewJobPage} /> */}
            {/* <PrivateRoute path="/jobs" component={Jobs} />
      <PrivateRoute path="/companies" component={Companies} /> */}

            <Route exact path="/log_in" component={LogIn} />
            <PrivateRoute path="/" component={wrappedRoutes} />
            {/* <div className="container__wrap"> */}
            {/* <Layout />
          <PrivateRoute path="/jobs" component={Jobs} />
          <PrivateRoute path="/companies" component={Companies} /> */}
            {/* <div> */}
            {/* </div> */}
            {/* </div> */}
            {/* <Route path="*" component={PostJob} /> */}
          </Switch>
        )}
      </main>
    </MainWrapper>
  );
};

export default connect(null, { signin, signout })(withRouter(Router));
